(function () {
  const observedSections = new WeakMap();

  function bindResponsiveProductMedia(section) {
    if (!section || observedSections.has(section)) return;
    const gallery = section.querySelector(".product__main");
    if (!gallery) return;

    const desktopViewport = window.matchMedia("(min-width: 990px)");
    const usesSlider = () =>
      (desktopViewport.matches
        ? gallery.dataset.layout || "gallery"
        : gallery.dataset.layoutMobile || "slider") === "slider";
    let currentMode = usesSlider();

    const onBreakpointChange = () => {
      const nextMode = usesSlider();
      if (nextMode === currentMode) return;
      currentMode = nextMode;
      if (typeof window.reinitProductMedia === "function") {
        window.reinitProductMedia(section);
      }
    };

    desktopViewport.addEventListener("change", onBreakpointChange);
    observedSections.set(section, () => {
      desktopViewport.removeEventListener("change", onBreakpointChange);
    });

    if (typeof window.reinitProductMedia === "function") {
      window.reinitProductMedia(section);
    }
  }

  document.addEventListener("shopify:section:load", function (e) {
    bindResponsiveProductMedia(e.target);
  });

  document.addEventListener("shopify:section:unload", function (e) {
    observedSections.get(e.target)?.();
    observedSections.delete(e.target);
  });

  bindResponsiveProductMedia(
    document.currentScript?.closest(".shopify-section") ||
      document.currentScript?.parentElement
  );
})();
